import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postCreateSingleDayJob, postCreateMultiDayJob } from '@/raptorjob/infrastructure/rest/createJob';
import { CreateRaptorJobResponse } from '@/raptorjob/domain/job-create-type';
import { ERPJobFormValues } from '@/raptorjob/presentation/ERPJobValidationSchema';
import { useMapERPJobPayload } from '@/raptorjob/application/adapters/useMapERPJobPayload';
import { RAPTOR_JOB_QUERY_KEYS } from '@/raptorjob/application/hooks/useRaptorJob';

export interface CreateERPJobVariables {
  values: ERPJobFormValues;
}

export const useCreateERPJob = () => {
  const queryClient = useQueryClient();
  const { mapERPPayload } = useMapERPJobPayload();
  return useMutation<CreateRaptorJobResponse, unknown, CreateERPJobVariables>({
    mutationKey: ['raptorJob:createERPSingleDay'],
    mutationFn: async (vars) => {
      const payload = mapERPPayload({ values: vars.values });

      // Use multi-day job endpoint for overnight jobs
      const isOvernight = vars.values.overnightJob ?? false;
      if (isOvernight) {
        return await postCreateMultiDayJob(payload, { useMock: false });
      }

      return await postCreateSingleDayJob(payload, { useMock: false });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: RAPTOR_JOB_QUERY_KEYS.raptorJobs });
    }
  });
};
